const doc = [({"da":({"activerecord":({"attributes":({"photo_session_csv":({"file":"Fil"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;